/* eslint-disable react-hooks/exhaustive-deps */
import { useAppInsights } from '@davies-group/error-handling';
import * as React from 'react';
import axios, { AxiosResponse } from 'axios';

import { DocumentRequest } from '../models';
import { applicationSettings } from '../utils';

const useDocumentRequestService = () => {
    const appInsights = useAppInsights();

    const checkResponse = <T>(url: string, response: AxiosResponse<T>): boolean => {
        if (response.status >= 200 && response.status <= 299) {
            appInsights.info(`Call to ${url} was successful`);
            return true;
        }

        throw new Error(`Failed to call ${url} (Status: ${response.status})`);
    };

    const getDocumentRequest = React.useCallback((requestId: string) => {
        const url = `${applicationSettings.documentRequestApiUrl}/v1.0/request/${requestId}`;

        return axios
            .get<DocumentRequest>(url)
            .then((response) => {
                checkResponse(url, response);
                return response.data;
            })
            .catch((err) => {
                appInsights.error(`Failed to call ${url} (Status: ${err})`, err);
                throw new Error(`Failed to call ${url} (Status: ${err})`);
            });
    }, []);

    const completeDocumentRequest = React.useCallback((requestId: string) => {
        const url = `${applicationSettings.documentRequestApiUrl}/v1.0/request/${requestId}/complete`;

        return axios
            .put<DocumentRequest>(url)
            .then((response) => {
                checkResponse(url, response);
                return true;
            })
            .catch((err) => {
                appInsights.error(`Failed to call ${url} (Status: ${err})`, err);
                throw new Error(`Failed to call ${url} (Status: ${err})`);
            });
    }, []);

    return { getDocumentRequest, completeDocumentRequest } as const;
};

export default useDocumentRequestService;
